import React, { PropsWithChildren, ReactElement } from 'react';
import { Popover, PopoverAlign } from 'react-tiny-popover';
import './Popover.scss';
import DropDownButton from '../Buttons/DropDownButton';

type FormPopoverProps = {
  label: string;
  show: boolean;
  align?: PopoverAlign;
  showDoneButton: boolean;
  targetButton?: ReactElement;
  toggleCallback: () => void;
  hideCallback: () => void;
  disableReposition: boolean;
  addClass?: string;
  addInnerClass?: string;
  id?: string;
};

const FormPopover = (props: PropsWithChildren<FormPopoverProps>): ReactElement => {
  const {
    label,
    show,
    align,
    showDoneButton,
    targetButton,
    toggleCallback,
    hideCallback,
    disableReposition,
    addClass,
    addInnerClass,
    children,
    id,
  } = props;

  return (
    <Popover
      align={align || 'center'}
      containerClassName={`form-popover-container ${addClass}`}
      content={
        <div className={`form-popover ${addInnerClass}`}>
          {showDoneButton && (
            <button
              className="done"
              id={`${id}-done`}
              onClick={hideCallback}
              type="button"
            >
              Done
            </button>
          )}
          <form>
            <div className="form-popover-label">{label}</div>
            <div className="form-group">{children}</div>
          </form>
        </div>
      }
      isOpen={show}
      onClickOutside={hideCallback}
      positions={['bottom', 'top', 'left', 'right']}
      reposition={!disableReposition}
    >
      {targetButton || (
        <DropDownButton
          dropdownDisplayed={show}
          id={id}
          label={label}
          onClick={toggleCallback}
        />
      )}
    </Popover>
  );
};

FormPopover.defaultProps = {
  align: 'start',
  disableReposition: true,
  showDoneButton: false,
};

export default FormPopover;
